import { type FC } from "react";
import { Check, Loader2, Pencil, X } from "lucide-react";

import { Button } from "@/shared/components/ui/button";

type ButtonSize = "sm" | "md";

interface AcceptDeclineActionsProps {
  onAccept: () => void;
  onDecline: () => void;
  onEdit?: () => void;
  loadingAction?: "accept" | "decline" | null;
  disabled?: boolean;
  size?: ButtonSize;
}

export const AcceptDeclineActions: FC<AcceptDeclineActionsProps> = ({
  onAccept,
  onDecline,
  onEdit,
  loadingAction,
  disabled,
  size = "md",
}) => {
  const isBusy = !!loadingAction || disabled;
  const iconSize = size === "sm" ? "h-3.5 w-3.5" : "h-4 w-4";

  return (
    <>
      <Button
        variant="outline"
        size={size}
        className="w-10 px-0"
        aria-label="Decline"
        onClick={onDecline}
        disabled={isBusy}
      >
        {loadingAction === "decline" ? (
          <Loader2 className={`${iconSize} animate-spin`} />
        ) : (
          <X className={`${iconSize} text-tertiary`} />
        )}
      </Button>
      {onEdit && (
        <Button
          variant="outline"
          size={size}
          className="w-10 px-0"
          aria-label="Edit"
          onClick={onEdit}
          disabled={isBusy}
        >
          <Pencil className={`${iconSize} text-tertiary`} />
        </Button>
      )}
      <Button variant="brand" size={size} onClick={onAccept} disabled={isBusy}>
        {loadingAction === "accept" ? (
          <Loader2 className="h-3.5 w-3.5 animate-spin" />
        ) : (
          <>
            Accept <Check className="h-3.5 w-3.5" />
          </>
        )}
      </Button>
    </>
  );
};
